/**
 * @flow
 * @relayHash 5b1d65b2a13f7bb85427f7114e756644
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RestoreBatchDeliverableFinalFilesInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type BatchRestoreDeliverableFinalFilesMutationVariables = {|
  input: RestoreBatchDeliverableFinalFilesInput
|};
export type BatchRestoreDeliverableFinalFilesMutationResponse = {|
  +restoreBatchDeliverableFinalFiles: ?{|
    +isRestoring: ?boolean
  |}
|};
export type BatchRestoreDeliverableFinalFilesMutation = {|
  variables: BatchRestoreDeliverableFinalFilesMutationVariables,
  response: BatchRestoreDeliverableFinalFilesMutationResponse,
|};
*/


/*
mutation BatchRestoreDeliverableFinalFilesMutation(
  $input: RestoreBatchDeliverableFinalFilesInput!
) {
  restoreBatchDeliverableFinalFiles(input: $input) {
    isRestoring
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RestoreBatchDeliverableFinalFilesInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "restoreBatchDeliverableFinalFiles",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreBatchDeliverableFinalFilesPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isRestoring",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BatchRestoreDeliverableFinalFilesMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BatchRestoreDeliverableFinalFilesMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "BatchRestoreDeliverableFinalFilesMutation",
    "id": null,
    "text": "mutation BatchRestoreDeliverableFinalFilesMutation(\n  $input: RestoreBatchDeliverableFinalFilesInput!\n) {\n  restoreBatchDeliverableFinalFiles(input: $input) {\n    isRestoring\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b63e2d5ac132dae2e009584448eaf51a';
module.exports = node;
